module.exports = __webpack_public_path__ + "img/photo_250460827_2.5241dd92.jpg";